<template>
   <!-- Nada se dibuja hasta tener los permisos: quien llega desde el enlace del
        correo recién iniciado sesión todavía no los tiene cargados, y el
        template los consulta en varios botones. -->
   <v-layout v-if="permisoVerificado" align-start>
      <v-flex xs12>
         <v-snackbar
            v-model="snackbar"
            :color="snackColor"
            :right="true"
            :bottom="true"
            :timeout="5000"
         >
            {{ snackText }}
            <template #action="{ attrs }">
               <v-btn
                  color="white"
                  text
                  v-bind="attrs"
                  @click="snackbar = false"
               >
                  Cerrar
               </v-btn>
            </template>
         </v-snackbar>

         <!-- ── CARGA DEL listado de alumnos ─────────────────────────────────────────── -->
         <v-dialog v-model="dialogCarga" persistent max-width="900px">
            <v-card>
               <v-card-title class="text-h6"> Cargar Alumnos </v-card-title>
               <v-card-text class="text--primary">
                  <v-row dense class="mb-2">
                     <v-col cols="12" sm="6">
                        <v-select
                           v-model="cicloCarga"
                           :items="ciclos"
                           label="Ciclo al que pertenece estos alumnos"
                           outlined
                           dense
                           hide-details
                        />
                     </v-col>
                     <v-col cols="12" sm="6">
                        <v-select
                           v-model="cicloAlternoCarga"
                           :items="ciclos"
                           label="Ciclo adicional (opcional)"
                           outlined
                           dense
                           hide-details
                           clearable
                        />
                     </v-col>
                  </v-row>
                  <p class="text-caption grey--text mb-3">
                     Usar el ciclo adicional cuando el mes pertenezca a dos
                     ciclos a la vez: en junio, Enfermería ya paga la cuota 1
                     del II-2026 mientras las demás carreras siguen en la cuota
                     6 del I-2026. Sin ese dato, esas carreras no obtienen
                     cuota.
                  </p>
                  <v-row dense class="mb-2">
                     <v-col cols="7">
                        <v-select
                           v-model="mesCarga"
                           :items="meses"
                           item-text="nombre"
                           item-value="valor"
                           label="Mes"
                           outlined
                           dense
                           hide-details
                        />
                     </v-col>
                     <v-col cols="5">
                        <v-text-field
                           v-model.number="anioCarga"
                           label="Año"
                           type="number"
                           outlined
                           dense
                           hide-details
                        />
                     </v-col>
                  </v-row>
                  <p class="text-caption grey--text mb-3">
                     Cada mes se guarda por separado, así que cargar este no
                     reemplaza los anteriores.
                  </p>

                  <v-file-input
                     v-model="archivo"
                     accept=".xlsx,.xls,.csv"
                     label="Archivo de listado oficial de alumnos"
                     prepend-icon="fas fa-file-excel"
                     outlined
                     dense
                     show-size
                     @change="leerArchivo"
                  />

                  <v-checkbox
                     v-model="darDeBajaFaltantes"
                     dense
                     hide-details
                     class="mt-0 mb-3"
                     label="Dar de baja a los becarios del ciclo que no vengan en este archivo"
                  />
                  <p class="text-caption grey--text mb-4">
                     Déjelo marcado cuando suba el archivo completo del mes: en
                     agosto llegaron 443 de los 480 de junio, y esos 37 son
                     bajas aunque no traigan motivo escrito. La baja solo
                     alcanza a {{ sedeDelSistema }}, que es lo único que sube
                     este sistema. Si sube un archivo parcial, desmárquelo.
                  </p>

                  <!-- El archivo de Registro Académico trae las dos sedes
                       mezcladas. No hace falta elegir: cada instalación sabe
                       cuál es la suya por VUE_APP_SEDE, así que se filtra sola
                       y se avisa qué quedó afuera. -->
                  <v-alert
                     v-if="previa.length"
                     dense
                     icon="fas fa-filter"
                     class="aviso-dorado mb-0"
                  >
                     Se leyeron <strong>{{ previa.length }}</strong> fila(s). Se
                     van a subir las
                     <strong>{{ previaSeleccion.length }}</strong> de
                     <strong>{{ sedeDelSistema }}</strong
                     >.
                     <template v-if="descartadasPorSede.length">
                        <br />
                        No se incluyen
                        {{
                           descartadasPorSede
                              .map((d) => d.cantidad + ' de ' + d.nombre)
                              .join(', ')
                        }}, que se cargan desde el sistema de la otra sede.
                     </template>
                  </v-alert>
               </v-card-text>
               <v-card-actions>
                  <v-spacer />
                  <v-btn text @click="cerrarCarga">Cancelar</v-btn>
                  <v-btn
                     color="primary"
                     :disabled="!previaSeleccion.length || !cicloCarga"
                     :loading="cargando"
                     @click="confirmarCarga"
                  >
                     Cargar {{ previaSeleccion.length }} fila(s)
                  </v-btn>
               </v-card-actions>
            </v-card>
         </v-dialog>

         <!-- ── RESULTADO DE LA CARGA ────────────────────────────────────── -->
         <v-dialog v-model="dialogResultado" max-width="760px">
            <v-card v-if="resultado">
               <v-card-title class="text-h6"
                  >Resultado de la carga</v-card-title
               >
               <v-card-text class="text--primary">
                  <v-row dense class="mb-2">
                     <v-col cols="3">
                        <v-card outlined class="pa-3 text-center">
                           <div class="text-h5 green--text">
                              {{ resultado.insertados }}
                           </div>
                           <div class="text-caption">Nuevos</div>
                        </v-card>
                     </v-col>
                     <v-col cols="3">
                        <v-card outlined class="pa-3 text-center">
                           <div class="text-h5 dorado--text">
                              {{ resultado.actualizados }}
                           </div>
                           <div class="text-caption">Actualizados</div>
                        </v-card>
                     </v-col>
                     <v-col cols="3">
                        <v-card outlined class="pa-3 text-center">
                           <div class="text-h5 orange--text">
                              {{ resultado.dadosDeBaja }}
                           </div>
                           <div class="text-caption">Dados de baja</div>
                        </v-card>
                     </v-col>
                     <v-col cols="3">
                        <v-card outlined class="pa-3 text-center">
                           <div class="text-h5 red--text">
                              {{ resultado.rechazados }}
                           </div>
                           <div class="text-caption">Rechazados</div>
                        </v-card>
                     </v-col>
                  </v-row>

                  <!-- Las carreras del listado quedan registradas solas en
                       Cuotas, sin monto. Lo que hay que resolver antes del corte
                       es ponerles precio, así que se dice acá mismo. -->
                  <v-alert
                     v-if="resultado.cuotasSinMonto"
                     dense
                     text
                     type="warning"
                     class="mb-2 text-body-2"
                  >
                     <span v-if="resultado.cuotasAgregadas">
                        Se registraron
                        <strong>{{ resultado.cuotasAgregadas }}</strong>
                        carrera(s) nueva(s) en la pestaña Cuotas.
                     </span>
                     Quedan
                     <strong>{{ resultado.cuotasSinMonto }}</strong>
                     carrera(s) sin monto. Asígneles la cuota que corresponde
                     antes de generar el corte: mientras estén en cero, sus
                     alumnos se reportan como faltantes.
                  </v-alert>

                  <!-- Movimiento entre fotos mensuales. Sale de comparar el
                       listado de este mes con el del anterior, no de lo que venga
                       escrito en el archivo. -->
                  <v-alert
                     v-if="resultado.bajasPorObservacion"
                     dense
                     icon="fas fa-info-circle"
                     class="aviso-dorado mb-2"
                  >
                     <strong>{{ resultado.bajasPorObservacion }}</strong>
                     fila(s) traían observación y quedaron dadas de baja.
                  </v-alert>

                  <!-- El archivo usa la misma columna para anotar altas; esas
                       quedan activas. -->
                  <v-alert
                     v-if="
                        resultado.altasPorMotivo &&
                        resultado.altasPorMotivo.length
                     "
                     dense
                     outlined
                     color="grey darken-4"
                     class="mb-2"
                  >
                     <div class="font-weight-medium mb-1">
                        {{ resultado.altasPorMotivo.length }} fila(s) con motivo
                        de incorporación quedaron activas
                     </div>
                     <ul class="mb-1">
                        <li v-for="(a, i) in resultado.altasPorMotivo" :key="i">
                           {{ a }}
                        </li>
                     </ul>
                     <div class="text-caption">
                        Tenían observación, pero el motivo indica un alta y no
                        una baja. Si alguna debía quedar inactiva, puede darla
                        de baja desde la tabla.
                     </div>
                  </v-alert>

                  <v-alert
                     v-if="resultado.mesAnterior"
                     dense
                     icon="fas fa-info-circle"
                     class="aviso-dorado mb-2"
                  >
                     Respecto de <strong>{{ resultado.mesAnterior }}</strong
                     >:
                     <strong class="green--text">
                        {{ resultado.altasRespectoMesAnterior }}
                     </strong>
                     alta(s) y
                     <strong class="orange--text">
                        {{ resultado.bajasRespectoMesAnterior }}
                     </strong>
                     baja(s).
                  </v-alert>

                  <v-alert
                     v-if="resultado.sinTarifa && resultado.sinTarifa.length"
                     dense
                     text
                     type="warning"
                  >
                     <strong>Sin cuotas.</strong> Estas carreras del archivo no
                     coinciden con ninguna de los contratos, así que sus
                     becarios quedan sin cuota y el corte no se podrá generar
                     hasta resolverlo:
                     <ul class="mt-2">
                        <li v-for="(s, i) in resultado.sinTarifa" :key="i">
                           {{ s }}
                        </li>
                     </ul>
                  </v-alert>

                  <template
                     v-if="resultado.rechazos && resultado.rechazos.length"
                  >
                     <div class="text-subtitle-2 mt-3 mb-1">
                        Filas rechazadas
                     </div>
                     <v-simple-table dense height="220" class="elevation-1">
                        <template #default>
                           <thead>
                              <tr>
                                 <th>Fila</th>
                                 <th>Carnet</th>
                                 <th>Motivo</th>
                              </tr>
                           </thead>
                           <tbody>
                              <tr v-for="(r, i) in resultado.rechazos" :key="i">
                                 <td>{{ r.fila }}</td>
                                 <td>{{ r.carnet }}</td>
                                 <td>{{ r.motivo }}</td>
                              </tr>
                           </tbody>
                        </template>
                     </v-simple-table>
                  </template>
               </v-card-text>
               <v-card-actions>
                  <v-spacer />
                  <v-btn color="primary" text @click="dialogResultado = false">
                     Entendido
                  </v-btn>
               </v-card-actions>
            </v-card>
         </v-dialog>

         <!-- ── PANTALLA DE CARGA ────────────────────────────────────────── -->
         <v-dialog
            v-model="generando"
            persistent
            no-click-animation
            max-width="420px"
         >
            <v-card class="text-center pa-8">
               <!-- Misma animación de hojas que usa ReporteTalonario. -->
               <div class="tal-anim-wrapper mb-5">
                  <div class="tal-page tal-p1">
                     <div class="tal-header"></div>
                  </div>
                  <div class="tal-page tal-p2">
                     <div class="tal-header"></div>
                  </div>
                  <div class="tal-page tal-p3">
                     <div class="tal-header"></div>
                  </div>
                  <div class="tal-page tal-p4">
                     <div class="tal-header"></div>
                  </div>
               </div>

               <p
                  class="font-weight-bold primary--text mb-2"
                  style="font-size: 22px"
               >
                  {{ generandoTitulo }}
               </p>
               <p
                  v-if="generandoDetalle"
                  class="font-weight-medium grey--text text--darken-3 mb-4"
                  style="font-size: 17px; letter-spacing: 1px"
               >
                  {{ generandoDetalle }}
               </p>

               <transition name="tal-msg-fade" mode="out-in">
                  <p
                     :key="loadingTextoIndex"
                     class="grey--text text--darken-1 mb-0"
                     style="font-size: 15px"
                  >
                     {{ loadingTextos[loadingTextoIndex] }}
                  </p>
               </transition>
            </v-card>
         </v-dialog>

         <!-- ── ASIGNAR CARRERA ──────────────────────────────────────────── -->
         <v-dialog v-model="dialogCarrera" max-width="620px">
            <v-card>
               <v-card-title class="text-h6">Asignar carrera</v-card-title>
               <v-card-text class="text--primary">
                  <v-alert dense text type="warning" class="mb-4">
                     El nombre que trae el archivo no coincide con una sola
                     carrera de los contratos. Ocurre cuando existen dos planes
                     de nombre muy parecido —presencial y semipresencial— con
                     precios distintos: asignarlo de forma automática podría
                     darle al alumno una cuota que no le corresponde.
                  </v-alert>
                  <p class="mb-1">
                     <strong>{{
                        becarioSel ? becarioSel.nombreCompleto : ''
                     }}</strong>
                  </p>
                  <p class="text-caption grey--text mb-4">
                     {{ becarioSel ? becarioSel.carnet : '' }} ·
                     {{ becarioSel ? becarioSel.sede : '' }} · archivo: «{{
                        becarioSel ? becarioSel.carreraNombre : ''
                     }}»
                  </p>
                  <v-select
                     v-model="carreraElegida"
                     :items="carrerasDisponibles"
                     :loading="cargandoCarreras"
                     item-text="nombre"
                     item-value="codigo"
                     label="Carrera según los contratos"
                     outlined
                     dense
                     hide-details
                  />
               </v-card-text>
               <v-card-actions>
                  <v-spacer />
                  <v-btn text @click="dialogCarrera = false">Cancelar</v-btn>
                  <v-btn
                     color="primary"
                     :disabled="!carreraElegida"
                     @click="guardarCarrera"
                  >
                     Asignar
                  </v-btn>
               </v-card-actions>
            </v-card>
         </v-dialog>

         <!-- ── OBSERVACIONES ────────────────────────────────────────────── -->
         <v-dialog v-model="dialogObservacion" max-width="560px">
            <v-card v-if="becarioObs">
               <v-card-title class="text-h6">
                  {{
                     becarioObs.activo ? 'Observaciones' : 'Motivo de la baja'
                  }}
               </v-card-title>
               <v-card-text class="text--primary">
                  <p class="mb-1 font-weight-medium">
                     {{ becarioObs.nombreCompleto }}
                  </p>
                  <p class="text-caption grey--text mb-4">
                     {{ becarioObs.carnet }} · {{ becarioObs.carreraNombre }} ·
                     {{ becarioObs.sede }}
                  </p>

                  <v-simple-table dense>
                     <template #default>
                        <tbody>
                           <tr>
                              <td
                                 class="font-weight-medium"
                                 style="width: 130px"
                              >
                                 Estado
                              </td>
                              <td>
                                 <v-chip
                                    x-small
                                    label
                                    :color="
                                       becarioObs.activo ? 'green' : 'grey'
                                    "
                                    text-color="white"
                                 >
                                    {{ becarioObs.activo ? 'Activo' : 'Baja' }}
                                 </v-chip>
                              </td>
                           </tr>
                           <tr v-if="becarioObs.fechaRetiro">
                              <td class="font-weight-medium">Fecha de baja</td>
                              <td>{{ becarioObs.fechaRetiro }}</td>
                           </tr>
                           <tr>
                              <td class="font-weight-medium">Motivo</td>
                              <td>{{ becarioObs.motivoRetiro || '—' }}</td>
                           </tr>
                           <tr>
                              <td class="font-weight-medium">Observación</td>
                              <td>{{ becarioObs.observacion || '—' }}</td>
                           </tr>
                        </tbody>
                     </template>
                  </v-simple-table>

                  <p class="text-caption grey--text mt-3 mb-0">
                     El motivo y la observación son los que trae el archivo de
                     los alumnos de este mes, o los que se escribieron al dar de
                     baja desde esta pantalla.
                  </p>
               </v-card-text>
               <v-card-actions>
                  <v-spacer />
                  <v-btn
                     color="primary"
                     text
                     @click="dialogObservacion = false"
                  >
                     Cerrar
                  </v-btn>
               </v-card-actions>
            </v-card>
         </v-dialog>

         <!-- ── BAJA ─────────────────────────────────────────────────────── -->
         <v-dialog v-model="dialogBaja" max-width="480px">
            <v-card>
               <v-card-title class="text-h6">Dar de baja</v-card-title>
               <v-card-text class="text--primary">
                  <p>
                     {{ becarioSel ? becarioSel.nombreCompleto : '' }}
                     ({{ becarioSel ? becarioSel.carnet : '' }})
                  </p>
                  <v-text-field
                     v-model="motivoBaja"
                     label="Motivo"
                     outlined
                     dense
                     hide-details
                  />
               </v-card-text>
               <v-card-actions>
                  <v-spacer />
                  <v-btn text @click="dialogBaja = false">Cancelar</v-btn>
                  <v-btn color="error" @click="confirmarBaja"
                     >Dar de baja</v-btn
                  >
               </v-card-actions>
            </v-card>
         </v-dialog>

         <!-- ── HABILITAR INSCRIPCIÓN ────────────────────────────────────── -->
         <v-dialog v-model="dialogInscripcion" max-width="720px" scrollable>
            <v-card>
               <v-card-title class="text-h6">
                  Habilitar inscripción en línea
               </v-card-title>
               <v-card-text class="text--primary">
                  <p>
                     A los siguientes becarios se les habilitará la inscripción
                     en línea: la cuota que les corresponde en
                     <strong>{{ mesEnTexto }}</strong> es la primera cuota.
                  </p>

                  <!-- Junio y diciembre se calculan con dos ciclos: uno arranca
                       y el otro termina. Como el listado no dice a cuál pertenece
                       cada becario, la lista abarca la carrera entera y hay que
                       decirlo en vez de dar a entender que ya está depurada. -->
                  <v-alert
                     v-if="ciclosDeInscripcion.length"
                     dense
                     icon="fas fa-info-circle"
                     class="aviso-dorado text-body-2"
                  >
                     La cuota 1 corresponde al ciclo
                     <strong>{{ ciclosDeInscripcion.join(' y ') }}</strong
                     >. Este mes se calculó con dos ciclos, así que la lista
                     incluye a toda la carrera: el archivo de los alumnos
                     todavía no registra en cuál de los dos está cada becario.
                  </v-alert>

                  <v-data-table
                     :headers="headersInscripcion"
                     :items="becariosDeInscripcion"
                     :items-per-page="10"
                     :footer-props="pieTabla"
                     dense
                     class="elevation-1"
                     no-data-text="Ningún becario paga cuota de inscripción este mes."
                  >
                     <template #[`item.cuotaUnicaes`]="{ item }">
                        {{ moneda(item.cuotaUnicaes) }}
                     </template>
                  </v-data-table>

                  <p class="text-caption grey--text mt-3 mb-0">
                     Por ahora esta pantalla solo muestra a quiénes incluye. La
                     opción aún no realiza ninguna acción.
                  </p>
               </v-card-text>
               <v-card-actions>
                  <v-spacer />
                  <v-btn
                     color="primary"
                     text
                     @click="dialogInscripcion = false"
                  >
                     Cerrar
                  </v-btn>
               </v-card-actions>
            </v-card>
         </v-dialog>

         <!-- ── GENERAR CORTE ────────────────────────────────────────────── -->
         <v-dialog v-model="dialogCorte" max-width="480px">
            <v-card>
               <v-card-title class="text-h6"
                  >Generar corte del mes</v-card-title
               >
               <v-card-text class="text--primary">
                  <v-alert dense icon="fas fa-info-circle" class="aviso-dorado">
                     El corte guarda de forma definitiva el monto de cada
                     becario. Los reportes se generan siempre a partir del
                     corte, de modo que el listado de un mes puede volver a
                     obtenerse idéntico meses después.
                  </v-alert>
                  <v-row dense>
                     <v-col cols="7">
                        <v-select
                           v-model="mesCorte"
                           :items="meses"
                           item-text="nombre"
                           item-value="valor"
                           label="Mes"
                           outlined
                           dense
                           hide-details
                        />
                     </v-col>
                     <v-col cols="5">
                        <v-text-field
                           v-model.number="anioCorte"
                           label="Año"
                           type="number"
                           outlined
                           dense
                           hide-details
                        />
                     </v-col>
                  </v-row>
               </v-card-text>
               <v-card-actions>
                  <v-spacer />
                  <v-btn text @click="dialogCorte = false">Cancelar</v-btn>
                  <v-btn
                     color="primary"
                     :loading="generandoCorte"
                     @click="confirmarCorte"
                  >
                     Generar
                  </v-btn>
               </v-card-actions>
            </v-card>
         </v-dialog>

         <!-- ── PANTALLA ─────────────────────────────────────────────────── -->
         <v-card>
            <v-toolbar color="primary" dark>
               <v-toolbar-title style="font-weight: 500">
                  Dirección de Integración
               </v-toolbar-title>

               <!-- Acá van solo los ciclos que YA tienen listado cargado: es
                    un selector para mirar lo que hay, y ofrecer los treinta y
                    pico del catálogo obligaría a buscar entre ciclos vacíos. El
                    catálogo completo sigue estando en el diálogo de carga, que
                    es donde sí hace falta para estrenar un ciclo nuevo.

                    Sigue siendo combobox para poder escribir uno a mano. -->
               <div class="mt-6 ml-3" style="width: 130px">
                  <v-combobox
                     v-model="cicloSeleccionado"
                     label="Ciclo"
                     :items="ciclosConPadron"
                     no-data-text="Sin padrones cargados"
                     @change="normalizarCiclo"
                  />
               </div>

               <!-- El listado se guarda por mes: hay que poder mirar cualquiera
                    de las fotos cargadas, no solo la última. -->
               <!-- Ancho generoso: la etiqueta lleva mes, año, cantidad de
                    becarios y, en los meses de empalme, el ciclo adicional
                    ("JUNIO 2026 · 411 · + I-2026"). -->
               <div class="mt-6 ml-3" style="width: 290px">
                  <v-autocomplete
                     v-model="periodoSeleccionado"
                     label="Mes"
                     :items="periodos"
                     :item-text="etiquetaPeriodo"
                     item-value="clave"
                     no-data-text="Sin padrones cargados"
                  />
               </div>

               <v-tooltip v-if="cicloAlternoDelMes" bottom>
                  <template #activator="{ on }">
                     <v-chip small label outlined class="ml-3" v-on="on">
                        + {{ cicloAlternoDelMes }}
                     </v-chip>
                  </template>
                  <span>
                     La cuota de este mes también se busca en el ciclo
                     {{ cicloAlternoDelMes }}, porque no todas las carreras
                     comienzan a cobrar en el mismo mes.
                  </span>
               </v-tooltip>

               <v-spacer />
               <v-btn
                  v-if="permController(34, 'crear')"
                  outlined
                  class="mr-2"
                  @click="abrirCarga"
               >
                  <v-icon left small>fas fa-file-upload</v-icon>
                  Cargar archivo de Registro Académico
               </v-btn>
            </v-toolbar>

            <!-- Pestañas con aspecto de botón: sin el subrayado fino de Vuetify,
                 la activa se rellena y se distingue de un vistazo. -->
            <v-tabs
               v-model="tab"
               hide-slider
               grow
               height="52"
               background-color="grey lighten-4"
               active-class="tab-activa"
               class="tabs-boton"
            >
               <v-tab class="tab-boton">
                  <v-icon left small>fas fa-users</v-icon>
                  Alumnos
               </v-tab>
               <v-tab class="tab-boton">
                  <v-icon left small>fas fa-dollar-sign</v-icon>
                  Cuotas
               </v-tab>
               <v-tab class="tab-boton">
                  <v-icon left small>fas fa-file-signature</v-icon>
                  Cortes y reportes
               </v-tab>
            </v-tabs>
            <v-divider />

            <v-tabs-items v-model="tab">
               <!-- listado -->
               <v-tab-item>
                  <v-card-text>
                     <PadronRegistroAcademico
                        :ciclo="cicloSeleccionado"
                        :ciclo-alterno="cicloAlternoDelMes"
                        :ciclos="ciclos"
                        @mensaje="mostrar"
                        @padron-importado="trasImportarPadron"
                     />

                     <v-row dense class="mb-1">
                        <v-col cols="12" sm="3">
                           <v-text-field
                              v-model="busqueda"
                              label="Buscar por nombre o carnet"
                              prepend-inner-icon="fas fa-search"
                              outlined
                              dense
                              hide-details
                              clearable
                           />
                        </v-col>
                        <v-col cols="12" sm="3">
                           <!-- Autocomplete y no select: son treinta y pico de
                                carreras y buscar escribiendo es más rápido. -->
                           <v-autocomplete
                              v-model="filtroCarrera"
                              :items="carrerasEnPadron"
                              label="Carrera"
                              outlined
                              dense
                              hide-details
                              clearable
                              no-data-text="Sin carreras"
                           />
                        </v-col>
                        <v-col cols="6" sm="2">
                           <v-select
                              v-model="filtroEstado"
                              :items="estados"
                              item-text="texto"
                              item-value="valor"
                              label="Estado"
                              outlined
                              dense
                              hide-details
                           />
                        </v-col>
                        <v-col cols="12" sm="2" class="d-flex align-center">
                           <v-chip label color="primary" outlined>
                              {{ becariosFiltrados.length }} becario(s)
                           </v-chip>
                        </v-col>

                        <!-- Solo con el filtro en «Solo bajas»: el reporte es
                             precisamente de las bajas del mes, y ofrecerlo
                             mientras se miran los activos confundiría sobre qué
                             se está exportando. -->
                        <v-col
                           v-if="verSoloBajas"
                           cols="12"
                           sm="3"
                           class="d-flex align-center"
                        >
                           <v-btn
                              small
                              color="green darken-2"
                              outlined
                              :loading="descargandoBajas"
                              :disabled="!becariosFiltrados.length"
                              @click="descargarBajas"
                           >
                              <v-icon left x-small>fas fa-file-excel</v-icon>
                              Reporte de bajas
                           </v-btn>
                        </v-col>
                     </v-row>

                     <!-- Solo aparece cuando las cuotas de este mes ya están
                          calculadas y salieron de la cuota 1 del contrato: ese
                          es el mes en que la carrera arranca y los becarios
                          están entrando. -->
                     <v-row v-if="hayCuotaDeInscripcion" dense class="mb-2">
                        <v-col cols="12" class="d-flex align-center flex-wrap">
                           <v-btn
                              color="#c6ab55"
                              dark
                              depressed
                              @click="dialogInscripcion = true"
                           >
                              <v-icon left small>fas fa-user-plus</v-icon>
                              Habilitar inscripción
                           </v-btn>
                           <span class="text-caption grey--text ml-3">
                              {{ becariosDeInscripcion.length }} becario(s) de
                              este mes pagan la cuota de inscripción.
                           </span>
                        </v-col>
                     </v-row>

                     <v-data-table
                        :headers="headersPadron"
                        :items="becariosFiltrados"
                        :loading="cargandoPadron"
                        :items-per-page="10"
                        :footer-props="pieTabla"
                        dense
                        class="elevation-1"
                        loading-text="Cargando alumnos..."
                        no-data-text="No hay becarios cargados para este ciclo."
                     >
                        <template #[`item.activo`]="{ item }">
                           <v-chip
                              x-small
                              label
                              :color="item.activo ? 'green' : 'grey'"
                              text-color="white"
                           >
                              {{ item.activo ? 'Activo' : 'Baja' }}
                           </v-chip>
                        </template>
                        <template #[`item.cuotaUnicaes`]="{ item }">
                           <span v-if="item.cuotaUnicaes">
                              {{ moneda(item.cuotaUnicaes) }}
                           </span>
                           <v-tooltip v-else bottom>
                              <template #activator="{ on }">
                                 <v-icon small color="orange" v-on="on">
                                    fas fa-exclamation-triangle
                                 </v-icon>
                              </template>
                              <span>Sin cuota para su carrera y cohorte</span>
                           </v-tooltip>
                        </template>
                        <template #[`item.montoIntegracion`]="{ item }">
                           <strong v-if="item.montoIntegracion">
                              {{ moneda(item.montoIntegracion) }}
                           </strong>
                        </template>
                        <template #[`item.obsOrden`]="{ item }">
                           <!-- Solo se ofrece cuando hay algo que leer: un icono
                                que abre un diálogo vacío es peor que no tenerlo. -->
                           <v-tooltip v-if="tieneObservaciones(item)" bottom>
                              <template #activator="{ on }">
                                 <v-icon
                                    small
                                    :color="
                                       item.activo
                                          ? 'grey darken-1'
                                          : 'orange darken-2'
                                    "
                                    v-on="on"
                                    @click="verObservaciones(item)"
                                 >
                                    fas fa-comment-dots
                                 </v-icon>
                              </template>
                              <span>
                                 {{
                                    item.activo
                                       ? 'Ver observaciones'
                                       : 'Ver motivo de la baja'
                                 }}
                              </span>
                           </v-tooltip>
                        </template>
                        <template #[`item.acciones`]="{ item }">
                           <v-tooltip v-if="!item.carreraCodigo" bottom>
                              <template #activator="{ on }">
                                 <v-icon
                                    small
                                    color="orange darken-2"
                                    class="mr-2"
                                    v-on="on"
                                    @click="abrirCarrera(item)"
                                 >
                                    fas fa-link
                                 </v-icon>
                              </template>
                              <span>Asignar carrera</span>
                           </v-tooltip>
                           <v-tooltip v-if="item.activo" bottom>
                              <template #activator="{ on }">
                                 <v-icon
                                    small
                                    color="error"
                                    v-on="on"
                                    @click="abrirBaja(item)"
                                 >
                                    fas fa-user-slash
                                 </v-icon>
                              </template>
                              <span>Dar de baja</span>
                           </v-tooltip>
                           <v-tooltip v-else bottom>
                              <template #activator="{ on }">
                                 <v-icon
                                    small
                                    color="green"
                                    v-on="on"
                                    @click="reactivar(item)"
                                 >
                                    fas fa-user-check
                                 </v-icon>
                              </template>
                              <span>Reactivar</span>
                           </v-tooltip>
                        </template>
                     </v-data-table>
                  </v-card-text>
               </v-tab-item>

               <!-- CUOTAS -->
               <v-tab-item>
                  <CuotasIntegracion
                     :ciclo="cicloSeleccionado"
                     @mensaje="mostrar"
                     @cuotas-cambiadas="listarPadron"
                  />
               </v-tab-item>

               <!-- CORTES Y REPORTES -->
               <v-tab-item>
                  <v-card-text>
                     <v-row dense class="mb-2" align="center">
                        <v-col cols="12" sm="3">
                           <v-btn
                              v-if="permController(34, 'crear')"
                              color="primary"
                              @click="dialogCorte = true"
                           >
                              <v-icon left small>fas fa-calendar-check</v-icon>
                              Generar corte del mes
                           </v-btn>
                        </v-col>
                        <v-spacer />
                        <!-- Los filtros salen de los cortes ya generados: no
                             tiene sentido ofrecer un año o un mes que no existe
                             todavía. -->
                        <v-col cols="6" sm="2">
                           <v-select
                              v-model="filtroCorteAnio"
                              :items="aniosEnCortes"
                              label="Año"
                              outlined
                              dense
                              hide-details
                              clearable
                           />
                        </v-col>
                        <v-col cols="6" sm="2">
                           <v-select
                              v-model="filtroCorteMes"
                              :items="mesesEnCortes"
                              item-text="texto"
                              item-value="valor"
                              label="Mes"
                              outlined
                              dense
                              hide-details
                              clearable
                           />
                        </v-col>
                        <v-col cols="6" sm="2">
                           <v-select
                              v-model="filtroCorteCiclo"
                              :items="ciclosEnCortes"
                              label="Ciclo"
                              outlined
                              dense
                              hide-details
                              clearable
                           />
                        </v-col>
                        <v-col cols="6" sm="2" class="d-flex align-center">
                           <v-chip label color="primary" outlined>
                              {{ cortesFiltrados.length }} corte(s)
                           </v-chip>
                        </v-col>
                     </v-row>

                     <v-data-table
                        :headers="headersCortes"
                        :items="cortesFiltrados"
                        :loading="cargandoCortes"
                        :items-per-page="10"
                        :footer-props="pieTabla"
                        dense
                        class="elevation-1"
                        no-data-text="Todavía no se ha generado ningún corte."
                     >
                        <template #[`item.cicloAlterno`]="{ item }">
                           <span v-if="item.cicloAlterno">
                              {{ item.cicloAlterno }}
                           </span>
                           <span v-else class="grey--text">—</span>
                        </template>
                        <template #[`item.totalMonto`]="{ item }">
                           <strong>{{ moneda(item.totalMonto) }}</strong>
                        </template>
                        <template #[`item.acciones`]="{ item }">
                           <v-btn
                              small
                              text
                              color="green darken-2"
                              :loading="
                                 descargando ===
                                 item.integracionCorteId + '-xls'
                              "
                              @click="descargarExcel(item)"
                           >
                              <v-icon left x-small>fas fa-file-excel</v-icon>
                              Excel
                           </v-btn>
                           <v-btn
                              small
                              text
                              color="red darken-2"
                              :loading="
                                 descargando ===
                                 item.integracionCorteId + '-pdf'
                              "
                              @click="descargarPdf(item)"
                           >
                              <v-icon left x-small>fas fa-file-pdf</v-icon>
                              PDF
                           </v-btn>
                           <v-btn
                              small
                              text
                              color="blue darken-3"
                              :loading="
                                 descargando ===
                                 item.integracionCorteId + '-doc'
                              "
                              @click="descargarWord(item)"
                           >
                              <v-icon left x-small>fas fa-file-word</v-icon>
                              Word
                           </v-btn>
                        </template>
                     </v-data-table>
                  </v-card-text>
               </v-tab-item>
            </v-tabs-items>
         </v-card>
      </v-flex>
   </v-layout>
</template>

<script>
import axios from 'axios'
import XLSX from 'xlsx'
import { authComputed } from '../../helpers'
import PadronRegistroAcademico from './PadronRegistroAcademico.vue'
import CuotasIntegracion from './CuotasIntegracion.vue'
import {
   generarExcelOficial,
   generarCartasPdf,
   generarExcelBajas
} from './reporteIntegracion'
import { generarCartasWord } from './cartaWord'

/**
 * Encabezados que se esperan en el archivo del listado. Se buscan por nombre y no
 * por posición: el archivo lo arman a mano y el orden de las columnas ha
 * cambiado entre entregas.
 */
const COLUMNAS = {
   sede: ['SEDE'],
   facultad: ['FACULTAD'],
   carrera: ['CARRERA'],
   nie: ['NIE'],
   carnet: ['CARNET', 'CARNE', 'CARNÉ'],
   apellido: ['APELLIDO', 'APELLIDOS'],
   nombre: ['NOMBRE', 'NOMBRES'],
   telefono: ['TELEFONO', 'TELÉFONO'],
   correoInstitucional: ['CORREO INSTITUCIONAL', 'CORREO']
}

export default {
   name: 'DireccionIntegracion',
   components: { CuotasIntegracion, PadronRegistroAcademico },
   data() {
      return {
         permisoVerificado: false,
         tab: 0,
         ciclos: [],
         ciclosConPadron: [],
         cicloSeleccionado: null,
         periodos: [],
         periodoSeleccionado: null,
         cicloCarga: null,
         cicloAlternoCarga: null,
         mesCarga: new Date().getMonth() + 1,
         anioCarga: new Date().getFullYear(),

         becarios: [],
         cargandoPadron: false,
         busqueda: '',
         descargandoBajas: false,
         filtroCarrera: null,
         filtroEstado: true,
         estados: [
            { texto: 'Solo activos', valor: true },
            { texto: 'Solo bajas', valor: false },
            { texto: 'Todos', valor: null }
         ],

         dialogCarga: false,
         archivo: null,
         previa: [],
         darDeBajaFaltantes: true,
         cargando: false,
         dialogResultado: false,
         resultado: null,

         dialogObservacion: false,
         becarioObs: null,

         dialogBaja: false,
         dialogInscripcion: false,
         becarioSel: null,
         motivoBaja: '',

         dialogCarrera: false,
         carrerasDisponibles: [],
         carreraElegida: null,
         cargandoCarreras: false,

         periodoPendiente: null,

         cortes: [],
         cargandoCortes: false,
         filtroCorteAnio: null,
         filtroCorteMes: null,
         filtroCorteCiclo: null,

         generando: false,
         generandoTitulo: '',
         generandoDetalle: '',
         loadingTextoIndex: 0,
         loadingTextoHandle: null,
         loadingTextos: [],
         dialogCorte: false,
         generandoCorte: false,
         mesCorte: new Date().getMonth() + 1,
         anioCorte: new Date().getFullYear(),
         descargando: null,
         meses: [
            { valor: 1, nombre: 'Enero' },
            { valor: 2, nombre: 'Febrero' },
            { valor: 3, nombre: 'Marzo' },
            { valor: 4, nombre: 'Abril' },
            { valor: 5, nombre: 'Mayo' },
            { valor: 6, nombre: 'Junio' },
            { valor: 7, nombre: 'Julio' },
            { valor: 8, nombre: 'Agosto' },
            { valor: 9, nombre: 'Septiembre' },
            { valor: 10, nombre: 'Octubre' },
            { valor: 11, nombre: 'Noviembre' },
            { valor: 12, nombre: 'Diciembre' }
         ],

         // Vuetify viene en inglés y el proyecto no configura idioma global, así
         // que el pie de las tablas se traduce acá.
         pieTabla: {
            'items-per-page-text': 'Filas por página',
            'items-per-page-options': [10, 25, 50, 100, -1],
            'items-per-page-all-text': 'Todas',
            'page-text': '{0}-{1} de {2}'
         },

         headersPadron: [
            { text: 'Carnet', value: 'carnet' },
            { text: 'Nombre completo', value: 'nombreCompleto' },
            { text: 'Carrera', value: 'carreraNombre' },
            { text: 'Fac.', value: 'facultadCodigo' },
            { text: 'Cohorte', value: 'cohorte' },
            { text: 'Cuota UNICAES', value: 'cuotaUnicaes' },
            { text: 'Aporte D.I.', value: 'montoIntegracion' },
            { text: 'Estado', value: 'activo' },
            // Ordena por el motivo, no por "tiene o no tiene": así se agrupan
            // todas las deserciones juntas, todas las bajas por salud juntas, y
            // las filas sin nada quedan al final.
            { text: 'Obs.', value: 'obsOrden', width: 60 },
            { text: '', value: 'acciones', sortable: false }
         ],
         headersInscripcion: [
            { text: 'Carnet', value: 'carnet' },
            { text: 'Nombre', value: 'nombreCompleto' },
            { text: 'Carrera', value: 'carreraNombre' },
            { text: 'Sede', value: 'sede' },
            { text: 'Promoción', value: 'cohorte' },
            { text: 'Cuota UNICAES', value: 'cuotaUnicaes' }
         ],
         headersCortes: [
            { text: 'Mes', value: 'mesNombre' },
            { text: 'Año', value: 'anio' },
            { text: 'Ciclo', value: 'ciclo' },
            { text: 'Ciclo adicional', value: 'cicloAlterno' },
            { text: 'Becados', value: 'totalBecados' },
            { text: 'Total', value: 'totalMonto' },
            { text: 'Generado', value: 'fechaCorte' },
            { text: 'Por', value: 'generadoPor' },
            { text: 'Reportes', value: 'acciones', sortable: false }
         ],

         snackbar: false,
         snackText: '',
         snackColor: 'success'
      }
   },
   computed: {
      ...authComputed,
      /** Carreras presentes en el listado que se está mirando, ordenadas. */
      carrerasEnPadron() {
         const nombres = new Set()
         this.becarios.forEach((b) => {
            if (b.carreraNombre) nombres.add(b.carreraNombre)
         })

         return [...nombres].sort((a, b) => a.localeCompare(b, 'es'))
      },
      becariosFiltrados() {
         const texto = (this.busqueda || '').toUpperCase().trim()

         return this.becarios.filter((b) => {
            if (this.filtroCarrera && b.carreraNombre !== this.filtroCarrera) {
               return false
            }
            if (!texto) return true

            return (
               (b.nombreCompleto || '').toUpperCase().includes(texto) ||
               (b.carnet || '').toUpperCase().includes(texto)
            )
         })
      },
      /**
       * El filtro de estado está en «Solo bajas». Se compara contra false y no
       * con un valor falsy: «Todos» vale null, y ese también es falsy.
       */
      verSoloBajas() {
         return this.filtroEstado === false
      },
      /** Años con al menos un corte, del más reciente al más viejo. */
      aniosEnCortes() {
         return [...new Set(this.cortes.map((c) => c.anio))].sort(
            (a, b) => b - a
         )
      },
      /** Meses con al menos un corte, en orden de calendario. */
      mesesEnCortes() {
         const meses = new Map()
         this.cortes.forEach((c) => meses.set(c.mes, c.mesNombre))

         return [...meses.entries()]
            .sort((a, b) => a[0] - b[0])
            .map(([valor, texto]) => ({ valor, texto }))
      },
      ciclosEnCortes() {
         return [...new Set(this.cortes.map((c) => c.ciclo))]
            .filter(Boolean)
            .sort()
      },
      cortesFiltrados() {
         return this.cortes.filter((c) => {
            if (this.filtroCorteAnio && c.anio !== this.filtroCorteAnio) {
               return false
            }
            if (this.filtroCorteMes && c.mes !== this.filtroCorteMes) {
               return false
            }
            if (this.filtroCorteCiclo && c.ciclo !== this.filtroCorteCiclo) {
               return false
            }
            return true
         })
      },
      /**
       * Becarios activos cuya cuota de este mes es la primera del contrato.
       *
       * Lo marca el backend al derivar la tarifa: si la mayoría de los contratos
       * de esa carrera va por la cuota 1, el mes es el de inscripción. Sale de
       * ahí y no del listado porque el becario no tiene contrato propio.
       */
      becariosDeInscripcion() {
         return this.becarios.filter((b) => b.esCuotaDeInscripcion && b.activo)
      },
      hayCuotaDeInscripcion() {
         return this.becariosDeInscripcion.length > 0
      },
      /**
       * Ciclos de los que sale la cuota 1. Solo se avisa cuando el mes se
       * calculó con dos: con uno solo el dato no agrega nada.
       */
      ciclosDeInscripcion() {
         if (!this.cicloAlternoDelMes) return []

         return [
            ...new Set(
               this.becariosDeInscripcion
                  .map((b) => b.cicloDeInscripcion)
                  .filter(Boolean)
            )
         ].sort()
      },
      /** Mes y año del listado, para el texto del diálogo. */
      mesEnTexto() {
         const p = this.periodos.find(
            (x) => x.clave === this.periodoSeleccionado
         )
         return p ? `${p.mesNombre} ${p.anio}` : 'este mes'
      },
      usuario() {
         return this.oidcUser ? this.oidcUser.name : 'Desconocido'
      },
      /** Ciclo adicional con el que se cargó el mes que se está mirando. */
      cicloAlternoDelMes() {
         const p = this.periodos.find(
            (x) => x.clave === this.periodoSeleccionado
         )
         return p ? p.cicloAlterno : null
      },
      /** Mes y año del listado que se está mirando. */
      periodo() {
         const p = this.periodos.find(
            (x) => x.clave === this.periodoSeleccionado
         )
         return p ? { mes: p.mes, anio: p.anio } : null
      },
      /**
       * La sede de esta instalación, según VUE_APP_SEDE. Santa Ana e Ilobasco
       * corren cada una su propio sistema contra su propia base, así que el
       * archivo se filtra solo y nadie tiene que acordarse de elegir.
       *
       * El backend de Ilobasco se nombra 'CRI' y el front 'IL': se aceptan las
       * dos formas y cualquier cosa que no sea Santa Ana cae ahí.
       */
      sedeDelSistema() {
         const sede = (process.env.VUE_APP_SEDE || 'SA').toUpperCase().trim()

         return sede === 'SA' ? 'SANTA ANA' : 'ILOBASCO'
      },
      /** Sedes presentes en el archivo, con cuántas filas trae cada una. */
      sedesEnArchivo() {
         const cuenta = {}
         this.previa.forEach((f) => {
            const sede = (f.sede || '(sin sede)').toUpperCase().trim()
            cuenta[sede] = (cuenta[sede] || 0) + 1
         })

         return Object.keys(cuenta)
            .sort()
            .map((nombre) => ({ nombre, cantidad: cuenta[nombre] }))
      },
      /** Lo que quedó afuera, para decirlo en vez de descartarlo en silencio. */
      descartadasPorSede() {
         return this.sedesEnArchivo.filter((s) => !this.esDeMiSede(s.nombre))
      },
      /** Lo que se va a subir es lo que quedó tras filtrar por la sede propia. */
      previaSeleccion() {
         return this.previaFiltrada
      },
      previaFiltrada() {
         return this.previa.filter((f) => this.esDeMiSede(f.sede))
      }
   },
   watch: {
      // Al llegar desde la campana de la barra superior, el detalle del envío
      // se abre en la pestaña del listado de alumnos.
      '$route.query.envioMes'(mes) {
         if (mes) this.tab = 0
      },
      cicloSeleccionado() {
         this.listarPeriodos()
         this.listarCortes()
      },
      periodoSeleccionado() {
         this.listarPadron()
      },
      filtroEstado() {
         this.listarPadron()
      }
   },
   created() {
      // Recién iniciada la sesión —p. ej. al entrar por el botón del correo de
      // aviso— los permisos todavía vienen en camino: App.vue los pide al
      // recibir el usuario. Se espera a que lleguen antes de decidir.
      if (!this.$store.state.localModule.permisos.length) {
         const dejarDeEsperar = this.$store.watch(
            (state) => state.localModule.permisos,
            (permisos) => {
               if (!permisos.length) return
               dejarDeEsperar()
               this.iniciar()
            }
         )
         return
      }
      this.iniciar()
   },
   beforeDestroy() {
      // Si alguien sale de la pantalla con la carga abierta, el intervalo de los
      // mensajes seguiría corriendo contra un componente que ya no existe.
      this.terminarCarga()
   },
   methods: {
      iniciar() {
         let puedeVer = false
         try {
            puedeVer = !!this.permController(34, 'ver')
         } catch (e) {
            // Sin fila para el controlador en UsuarioPermisos: no tiene acceso.
         }

         if (!puedeVer) {
            this.$router.push({ name: 'inicio' })
            return
         }

         this.permisoVerificado = true
         this.listarCiclos()
      },
      /**
       * ¿Esta fila del archivo es de la sede de este sistema?
       *
       * El archivo lo escriben a mano y la sede llega como venga: con acentos,
       * en minúscula, como 'CRI' o 'IL' en vez de 'ILOBASCO'. Se compara sobre
       * el texto normalizado y no letra por letra, o se descartarían filas
       * buenas en silencio, que es lo peor que puede pasar acá.
       */
      esDeMiSede(sede) {
         // Se compara sin acentos, sin espacios y sin puntuación: así
         // 'Santa Ana', 'SANTA  ANA' y 'UNICAES C.R.I' caen donde tienen que
         // caer sin necesidad de enumerar cada forma.
         const compacto = (sede || '')
            .normalize('NFD')
            .replace(/[̀-ͯ]/g, '')
            .toUpperCase()
            .replace(/[^A-Z]/g, '')

         if (this.sedeDelSistema === 'SANTA ANA') {
            return compacto.includes('SANTAANA') || compacto === 'SA'
         }

         return (
            compacto.includes('ILOBASCO') ||
            compacto.includes('CRI') ||
            compacto === 'IL'
         )
      },
      mostrar(texto, color = 'success') {
         this.snackText = texto
         this.snackColor = color
         this.snackbar = true
      },
      moneda(valor) {
         return `$${Number(valor || 0).toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
         })}`
      },

      /**
       * Dos listas de ciclos, y a propósito.
       *
       * El catálogo (api/Ciclos) alimenta el diálogo de carga: para estrenar un
       * ciclo hay que poder elegirlo antes de que exista ningún listado suyo.
       *
       * El selector de arriba, en cambio, sirve para mirar lo ya cargado, así
       * que se llena con los ciclos que tienen listado (api/Integracion/ciclos,
       * que sale de IntegracionBecarios). Ofrecer ahí los treinta y pico del
       * catálogo obliga a buscar entre ciclos vacíos.
       */
      listarCiclos() {
         axios
            .get('api/Ciclos')
            .then(({ data }) => {
               const delCatalogo = (data || [])
                  .map((c) => c.nombre)
                  .filter((n) => !!n)

               this.ciclos = delCatalogo.length
                  ? delCatalogo
                  : [this.cicloActual()]
            })
            .catch(() => {
               this.ciclos = [this.cicloActual()]
            })

         this.listarCiclosConPadron()
      },
      /** Ciclos que ya tienen listado. Es lo que ofrece el selector de arriba. */
      listarCiclosConPadron() {
         axios
            .get('api/Integracion/ciclos')
            .then(({ data }) => {
               this.ciclosConPadron = (data || []).filter((c) => !!c)

               // La selección solo se toca si no había una o si dejó de existir.
               // Esto se vuelve a llamar después de cada carga y no debe sacar al
               // usuario del ciclo que está mirando.
               if (
                  !this.cicloSeleccionado ||
                  !this.ciclosConPadron.includes(this.cicloSeleccionado)
               ) {
                  this.cicloSeleccionado = this.ciclosConPadron.length
                     ? this.ciclosConPadron[0]
                     : null
               } else {
                  this.listarPeriodos()
               }
            })
            .catch((error) => {
               console.log(error)
               this.ciclosConPadron = []
            })
      },
      /**
       * El combobox deja escribir libre, así que se normaliza a mayúsculas y sin
       * espacios: el backend compara el ciclo tal cual y "ii-2026" no cruzaría
       * con "II-2026".
       */
      normalizarCiclo(valor) {
         if (typeof valor === 'string') {
            this.cicloSeleccionado = valor.trim().toUpperCase()
         }
      },
      cicloActual() {
         const hoy = new Date()
         return `${hoy.getMonth() < 6 ? 'I' : 'II'}-${hoy.getFullYear()}`
      },

      /** Los meses ya cargados del ciclo. El listado guarda una foto por mes. */
      listarPeriodos() {
         if (!this.cicloSeleccionado) {
            this.periodos = []
            this.periodoSeleccionado = null
            return
         }

         axios
            .get('api/Integracion/periodos', {
               params: { ciclo: this.cicloSeleccionado }
            })
            .then(({ data }) => {
               this.periodos = data.map((p) => ({
                  ...p,
                  clave: `${p.anio}-${p.mes}`
               }))

               // El mes recién cargado tiene prioridad; si no hay ninguno
               // pendiente se mantiene el elegido, y si ese ya no existe, el
               // último.
               const deseado = this.periodoPendiente || this.periodoSeleccionado
               this.periodoPendiente = null

               const anterior = this.periodoSeleccionado
               const sigue = this.periodos.some((p) => p.clave === deseado)

               this.periodoSeleccionado = sigue
                  ? deseado
                  : this.periodos.length
                  ? this.periodos[0].clave
                  : null

               // Si la clave cambió, el watcher ya recarga el listado; si quedó
               // igual no dispara y hay que pedirlo a mano. Distinguirlo evita
               // pedir el listado dos veces por cada carga.
               if (this.periodoSeleccionado === anterior) {
                  if (this.periodoSeleccionado) this.listarPadron()
                  else this.becarios = []
               }
            })
            .catch((error) => {
               console.log(error)
               this.periodos = []
               this.periodoSeleccionado = null
            })
      },
      /**
       * El listado pertenece a un solo ciclo, así que el selector de arriba sigue
       * siendo uno. El ciclo adicional —donde también se busca la cuota— se
       * muestra acá para que no quede como estado invisible.
       */
      etiquetaPeriodo(p) {
         const base = `${p.mesNombre} ${p.anio} · ${p.becarios}`
         return p.cicloAlterno ? `${base} · + ${p.cicloAlterno}` : base
      },
      abrirCarga() {
         this.cicloCarga = this.cicloSeleccionado

         const p = this.periodo
         if (p) {
            // Se propone el mes siguiente al último cargado, que es lo habitual.
            this.mesCarga = p.mes === 12 ? 1 : p.mes + 1
            this.anioCarga = p.mes === 12 ? p.anio + 1 : p.anio
         }
         this.dialogCarga = true
      },

      listarPadron() {
         if (!this.cicloSeleccionado) return
         const periodo = this.periodo
         if (!periodo) {
            this.becarios = []
            return
         }
         this.cargandoPadron = true

         const params = {
            Ciclo: this.cicloSeleccionado,
            Mes: periodo.mes,
            Anio: periodo.anio
         }
         if (this.filtroEstado !== null) params.Activo = this.filtroEstado

         axios
            .get('api/Integracion/becarios', { params })
            .then(({ data }) => {
               // Vuetify ordena por el valor de la columna, y la de observaciones
               // solo dibuja un icono. Se le agrega el texto por el cual ordenar:
               // el motivo, o la observación si no hay motivo.
               this.becarios = data.map((b) => ({
                  ...b,
                  obsOrden: b.motivoRetiro || b.observacion || ''
               }))
            })
            .catch((error) => {
               console.log(error)
               this.mostrar(
                  'No se pudo cargar el archivo de los alumnos.',
                  'error'
               )
            })
            .finally(() => {
               this.cargandoPadron = false
            })
      },

      // ── Carga del archivo ─────────────────────────────────────────────
      leerArchivo(file) {
         this.previa = []
         if (!file) return

         const reader = new FileReader()
         reader.onload = (e) => {
            try {
               const wb = XLSX.read(new Uint8Array(e.target.result), {
                  type: 'array'
               })
               const hoja = wb.Sheets[wb.SheetNames[0]]
               const filas = XLSX.utils.sheet_to_json(hoja, {
                  header: 1,
                  raw: false,
                  defval: ''
               })

               this.previa = this.mapearFilas(filas)

               if (!this.previa.length) {
                  this.mostrar(
                     'No se encontró una fila de encabezados con la columna CARNET.',
                     'error'
                  )
               }
            } catch (error) {
               console.log(error)
               this.mostrar('No se pudo leer el archivo.', 'error')
            }
         }
         reader.readAsArrayBuffer(file)
      },

      /**
       * Ubica la fila de encabezados y traduce cada fila a la forma que espera
       * el backend. Las columnas sin encabezado que van después de la última
       * conocida son, en orden, motivo / fecha / observación.
       */
      mapearFilas(filas) {
         const normaliza = (v) =>
            (v || '')
               .toString()
               .normalize('NFD')
               .replace(/[̀-ͯ]/g, '')
               .toUpperCase()
               .trim()

         const iHeader = filas.findIndex((f) =>
            f.some((c) => ['CARNET', 'CARNE'].includes(normaliza(c)))
         )
         if (iHeader === -1) return []

         const encabezados = filas[iHeader].map(normaliza)
         const indices = {}
         let ultima = -1

         Object.keys(COLUMNAS).forEach((campo) => {
            const idx = encabezados.findIndex((h) =>
               COLUMNAS[campo].some((alias) => h === normaliza(alias))
            )
            indices[campo] = idx
            if (idx > ultima) ultima = idx
         })

         const extras = [ultima + 1, ultima + 2, ultima + 3]

         return filas
            .slice(iHeader + 1)
            .map((f) => ({
               sede: this.celda(f, indices.sede),
               facultad: this.celda(f, indices.facultad),
               carrera: this.celda(f, indices.carrera),
               nie: this.celda(f, indices.nie),
               carnet: this.celda(f, indices.carnet),
               apellido: this.celda(f, indices.apellido),
               nombre: this.celda(f, indices.nombre),
               telefono: this.celda(f, indices.telefono),
               correoInstitucional: this.celda(f, indices.correoInstitucional),
               motivoRetiro: this.celda(f, extras[0]),
               fechaMotivo: this.celda(f, extras[1]),
               observacion: this.celda(f, extras[2])
            }))
            .filter((f) => f.carnet)
      },
      celda(fila, indice) {
         if (indice === undefined || indice < 0) return ''
         return (fila[indice] || '').toString().trim()
      },

      confirmarCarga() {
         this.cargando = true
         axios
            .post('api/Integracion/becarios/cargar', {
               ciclo: this.cicloCarga,
               cicloAlterno: this.cicloAlternoCarga,
               mes: this.mesCarga,
               anio: this.anioCarga,
               usuario: this.usuario,
               darDeBajaFaltantes: this.darDeBajaFaltantes,
               becarios: this.previaSeleccion
            })
            .then(({ data }) => {
               this.resultado = data
               this.dialogResultado = true
               this.cerrarCarga()

               // Se salta al ciclo y mes recién cargados, pero el mes NO se
               // asigna acá: si es un mes nuevo todavía no está en la lista, y
               // dejarlo apuntando a algo inexistente hace que el período valga
               // null por un instante. En ese hueco la pestaña de Cuotas pide
               // las tarifas sin filtrar por mes y se queda mostrando las de
               // otro. Se deja anotado y listarPeriodos() lo aplica cuando ya
               // tiene la lista.
               //
               // El catálogo no se vuelve a pedir, pero la lista de ciclos CON
               // listado sí: puede que este ciclo acabe de estrenarse y todavía
               // no esté en el selector de arriba.
               this.periodoPendiente = `${this.anioCarga}-${this.mesCarga}`

               if (!this.ciclosConPadron.includes(this.cicloCarga)) {
                  this.ciclosConPadron = [this.cicloCarga]
                     .concat(this.ciclosConPadron)
                     .sort()
                     .reverse()
               }

               // Cambiar el ciclo ya dispara listarPeriodos() por el watcher;
               // llamarlo además dejaría dos peticiones compitiendo.
               if (this.cicloSeleccionado !== this.cicloCarga) {
                  this.cicloSeleccionado = this.cicloCarga
               } else {
                  this.listarPeriodos()
               }
            })
            .catch((error) => {
               console.log(error)
               this.mostrar(
                  error.response && error.response.data
                     ? error.response.data
                     : 'No se pudo cargar la información.',
                  'error'
               )
            })
            .finally(() => {
               this.cargando = false
            })
      },
      cerrarCarga() {
         this.dialogCarga = false
         this.archivo = null
         this.previa = []
      },

      // ── Carrera sin resolver ──────────────────────────────────────────
      abrirCarrera(item) {
         this.becarioSel = item
         this.carreraElegida = null
         this.carrerasDisponibles = []
         this.dialogCarrera = true
         this.cargandoCarreras = true

         axios
            .get('api/Integracion/carreras', {
               params: { ciclo: this.cicloSeleccionado, sede: item.sede }
            })
            .then(({ data }) => {
               this.carrerasDisponibles = data
            })
            .catch(() =>
               this.mostrar(
                  'No se pudo cargar el catálogo de carreras.',
                  'error'
               )
            )
            .finally(() => {
               this.cargandoCarreras = false
            })
      },
      guardarCarrera() {
         axios
            .patch(
               `api/Integracion/becarios/${this.becarioSel.integracionBecarioId}/carrera`,
               null,
               {
                  params: { codigo: this.carreraElegida, usuario: this.usuario }
               }
            )
            .then(() => {
               this.dialogCarrera = false
               this.mostrar('Carrera asignada. Vuelva a precargar las cuotas.')
               this.listarPadron()
            })
            .catch(() =>
               this.mostrar('No se pudo asignar la carrera.', 'error')
            )
      },

      // ── Observaciones ─────────────────────────────────────────────────
      tieneObservaciones(item) {
         return !!(item.motivoRetiro || item.observacion || item.fechaRetiro)
      },
      verObservaciones(item) {
         this.becarioObs = item
         this.dialogObservacion = true
      },

      // ── Altas y bajas ─────────────────────────────────────────────────
      abrirBaja(item) {
         this.becarioSel = item
         this.motivoBaja = ''
         this.dialogBaja = true
      },
      confirmarBaja() {
         axios
            .patch(
               `api/Integracion/becarios/${this.becarioSel.integracionBecarioId}/desactivar`,
               null,
               { params: { usuario: this.usuario, motivo: this.motivoBaja } }
            )
            .then(() => {
               this.dialogBaja = false
               this.mostrar('Becario dado de baja.')
               this.listarPadron()
            })
            .catch(() => this.mostrar('No se pudo dar de baja.', 'error'))
      },
      reactivar(item) {
         axios
            .patch(
               `api/Integracion/becarios/${item.integracionBecarioId}/reactivar`,
               null,
               { params: { usuario: this.usuario } }
            )
            .then(() => {
               this.mostrar('Becario reactivado.')
               this.listarPadron()
            })
            .catch(() => this.mostrar('No se pudo reactivar.', 'error'))
      },

      // ── Cortes y reportes ─────────────────────────────────────────────
      listarCortes() {
         if (!this.cicloSeleccionado) return
         this.cargandoCortes = true

         axios
            .get('api/Integracion/cortes', {
               params: { ciclo: this.cicloSeleccionado }
            })
            .then(({ data }) => {
               this.cortes = data
            })
            .catch((error) => console.log(error))
            .finally(() => {
               this.cargandoCortes = false
            })
      },
      confirmarCorte() {
         this.generandoCorte = true
         axios
            .post('api/Integracion/cortes', {
               ciclo: this.cicloSeleccionado,
               mes: this.mesCorte,
               anio: this.anioCorte,
               usuario: this.usuario
            })
            .then(() => {
               this.dialogCorte = false
               this.mostrar('Corte generado.')
               this.listarCortes()
            })
            .catch((error) => {
               this.mostrar(
                  error.response && error.response.data
                     ? error.response.data
                     : 'No se pudo generar el corte.',
                  'error'
               )
            })
            .finally(() => {
               this.generandoCorte = false
            })
      },
      /**
       * Abre la pantalla de carga y arranca la rotación de mensajes.
       *
       * Los mensajes van cambiando porque armar el archivo bloquea el hilo del
       * navegador a ratos: sin algo que se mueva, una espera de dos o tres
       * segundos se lee como que la pantalla se colgó.
       */
      iniciarCarga(titulo, detalle, textos) {
         this.generandoTitulo = titulo
         this.generandoDetalle = detalle
         this.loadingTextos = textos
         this.loadingTextoIndex = 0
         this.generando = true

         this.loadingTextoHandle = setInterval(() => {
            this.loadingTextoIndex =
               (this.loadingTextoIndex + 1) % this.loadingTextos.length
         }, 1600)
      },
      terminarCarga() {
         if (this.loadingTextoHandle) {
            clearInterval(this.loadingTextoHandle)
            this.loadingTextoHandle = null
         }
         this.generando = false
      },

      /**
       * Pide el corte al backend midiendo cuánto tarda. Separarlo del armado del
       * archivo es lo que permite ver si una descarga lenta es culpa del
       * servidor o del navegador.
       */
      obtenerReporte(item) {
         const inicio = performance.now()

         return axios
            .get(`api/Integracion/cortes/${item.integracionCorteId}/reporte`)
            .then(({ data }) => {
               const ms = performance.now() - inicio
               console.log(
                  `[INTEGRACION] Corte descargado del API en ${ms.toFixed(
                     0
                  )} ms` +
                     ` (${data.detalle ? data.detalle.length : 0} becarios)`
               )
               return data
            })
      },
      /**
       * El listado del mes lo acaba de reemplazar Registro Académico. Se releen
       * los períodos —el mes puede no existir antes de esta importación— y
       * después el listado, para no dejar la pantalla mostrando lo anterior.
       */
      trasImportarPadron({ anio, mes, ciclo }) {
         // Mismo camino que después de subir el archivo: el mes puede no existir
         // todavía en la lista, así que se deja anotado y listarPeriodos() lo
         // aplica cuando ya la tiene.
         this.periodoPendiente = `${anio}-${mes}`

         if (ciclo && !this.ciclosConPadron.includes(ciclo)) {
            this.ciclosConPadron = [ciclo]
               .concat(this.ciclosConPadron)
               .sort()
               .reverse()
         }

         // Cambiar el ciclo ya dispara listarPeriodos() por el watcher; llamarlo
         // además dejaría dos peticiones compitiendo.
         if (ciclo && this.cicloSeleccionado !== ciclo) {
            this.cicloSeleccionado = ciclo
         } else {
            this.listarPeriodos()
         }
      },
      /**
       * Reporte de las bajas del mes, con los filtros que estén puestos: lo que
       * se ve en la tabla es lo que sale en el archivo.
       */
      descargarBajas() {
         const periodo = this.periodos.find(
            (p) => p.clave === this.periodoSeleccionado
         )

         this.descargandoBajas = true

         generarExcelBajas(this.becariosFiltrados, {
            ciclo: this.cicloSeleccionado,
            mes: periodo ? periodo.mes : null,
            anio: periodo ? periodo.anio : null,
            mesNombre: periodo ? periodo.mesNombre : null,
            carrera: this.filtroCarrera,
            busqueda: this.busqueda
         })
            .then(() => {
               this.mostrar(
                  `Reporte generado con ${this.becariosFiltrados.length} baja(s).`
               )
            })
            .catch((error) => {
               console.log(error)
               this.mostrar('No se pudo generar el reporte de bajas.', 'error')
            })
            .finally(() => {
               this.descargandoBajas = false
            })
      },
      descargarExcel(item) {
         this.descargando = item.integracionCorteId + '-xls'
         const inicio = performance.now()

         this.iniciarCarga(
            'Generando el listado oficial',
            `${item.mesNombre} ${item.anio}`,
            [
               'Consultando el corte del mes...',
               'Abriendo la plantilla oficial...',
               'Llenando las cuatro hojas...',
               'Escribiendo el archivo...'
            ]
         )

         this.obtenerReporte(item)
            .then((reporte) => generarExcelOficial(reporte))
            .then(() => {
               const ms = performance.now() - inicio
               console.log(
                  `[INTEGRACION] Excel listo: ${ms.toFixed(0)} ms desde el clic`
               )
               this.mostrar('Listado oficial generado.')
            })
            .catch((error) => {
               console.log(error)
               this.mostrar('No se pudo generar el Excel.', 'error')
            })
            .finally(() => {
               this.terminarCarga()
               this.descargando = null
            })
      },
      descargarPdf(item) {
         this.descargando = item.integracionCorteId + '-pdf'
         const inicio = performance.now()

         this.iniciarCarga(
            'Preparando las cartas oficiales',
            `${item.mesNombre} ${item.anio} · ${item.totalBecados} becarios`,
            [
               'Consultando el corte del mes...',
               'Ordenando los becarios por sede...',
               'Componiendo el listado nominal...',
               'Armando el resumen por carreras...',
               'Generando el documento...'
            ]
         )

         this.obtenerReporte(item)
            .then((reporte) => generarCartasPdf(reporte))
            .then(() => {
               const ms = performance.now() - inicio
               console.log(
                  `[INTEGRACION] Cartas listas: ${ms.toFixed(
                     0
                  )} ms desde el clic`
               )
               this.mostrar('Cartas generadas, una por sede.')
            })
            .catch((error) => {
               console.log(error)
               this.mostrar('No se pudieron generar las cartas.', 'error')
            })
            .finally(() => {
               this.terminarCarga()
               this.descargando = null
            })
      },
      // La misma carta del PDF, en un documento que se puede editar antes de
      // enviarlo.
      descargarWord(item) {
         this.descargando = item.integracionCorteId + '-doc'
         const inicio = performance.now()

         this.iniciarCarga(
            'Preparando las cartas en Word',
            `${item.mesNombre} ${item.anio} · ${item.totalBecados} becarios`,
            [
               'Consultando el corte del mes...',
               'Ordenando los becarios por sede...',
               'Componiendo el listado nominal...',
               'Armando el resumen por carreras...',
               'Generando el documento...'
            ]
         )

         this.obtenerReporte(item)
            .then((reporte) => generarCartasWord(reporte))
            .then(() => {
               const ms = performance.now() - inicio
               console.log(
                  `[INTEGRACION] Cartas Word listas: ${ms.toFixed(
                     0
                  )} ms desde el clic`
               )
               this.mostrar('Cartas en Word generadas, una por sede.')
            })
            .catch((error) => {
               console.log(error)
               this.mostrar(
                  'No se pudieron generar las cartas en Word.',
                  'error'
               )
            })
            .finally(() => {
               this.terminarCarga()
               this.descargando = null
            })
      }
   }
}
</script>

<style scoped>
/* El dorado del módulo, el mismo del contorno de las pestañas. */
.dorado--text {
   color: #c6ab55 !important;
}

/* Aviso informativo: contorno dorado, fondo blanco y letra negra.
   El azul que trae Vuetify desentona con el rojo y el dorado de la pantalla,
   pero el texto en dorado sobre blanco tampoco se lee: el color queda en el
   borde y en el ícono, y lo que hay que leer va en negro. */
.aviso-dorado {
   background-color: #ffffff !important;
   border: 1px solid #c6ab55 !important;
   color: rgba(0, 0, 0, 0.87) !important;
}
.aviso-dorado >>> .v-alert__icon {
   color: #c6ab55 !important;
}

/* === Pestañas con aspecto de botón === */
.tabs-boton {
   padding: 6px;
}
.tab-boton {
   border-radius: 6px;
   margin-right: 6px;
   font-weight: 600;
   letter-spacing: 0.2px;
   text-transform: none;
   color: rgba(0, 0, 0, 0.6);
   /* Dorado institucional: marca el contorno de las tres pestañas, estén
      activas o no, para que se lean como un grupo de botones. */
   border: 1px solid #c6ab55;
   transition: background-color 0.2s ease, color 0.2s ease;
}
.tab-boton:last-child {
   margin-right: 0;
}
/* La inactiva se insinúa al pasar el mouse; la activa va rellena, que es lo
   que hace evidente en cuál estás parado. */
.tab-boton:hover {
   background-color: rgba(0, 0, 0, 0.04);
}
.tab-boton.tab-activa {
   background-color: var(--v-primary-base);
   color: #ffffff !important;
   border-color: #c6ab55;
   box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
}
.tab-boton.tab-activa:hover {
   background-color: var(--v-primary-base);
}

/* === Animación de hojas, la misma de ReporteTalonario === */
.tal-anim-wrapper {
   position: relative;
   width: 110px;
   height: 145px;
   margin: 0 auto;
}
.tal-page {
   position: absolute;
   width: 82px;
   height: 112px;
   border-radius: 4px;
   background: #ffffff;
   border: 2px solid var(--v-primary-base);
   box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.18);
   top: 16px;
   left: 14px;
   opacity: 0;
   animation: talPageSlide 2.4s ease-in-out infinite;
   overflow: hidden;
}
.tal-page::after {
   content: '';
   position: absolute;
   top: 30px;
   left: 10px;
   right: 10px;
   height: 2px;
   background: var(--v-primary-base);
   opacity: 0.25;
   box-shadow: 0 9px 0 rgba(25, 118, 210, 0.2), 0 18px 0 rgba(25, 118, 210, 0.2),
      0 27px 0 rgba(25, 118, 210, 0.2), 0 36px 0 rgba(25, 118, 210, 0.2),
      0 45px 0 rgba(25, 118, 210, 0.2), 0 54px 0 rgba(25, 118, 210, 0.2);
}
.tal-header {
   position: absolute;
   top: 8px;
   left: 10px;
   right: 10px;
   height: 14px;
   border-radius: 2px;
   background: var(--v-primary-base);
   opacity: 0.5;
}
.tal-p1 {
   --rot: -6deg;
   animation-delay: 0s;
}
.tal-p2 {
   --rot: -2deg;
   animation-delay: 0.6s;
}
.tal-p3 {
   --rot: 3deg;
   animation-delay: 1.2s;
}
.tal-p4 {
   --rot: -1deg;
   animation-delay: 1.8s;
}

@keyframes talPageSlide {
   0% {
      transform: translateY(-55px) rotate(var(--rot));
      opacity: 0;
   }
   18% {
      transform: translateY(0) rotate(var(--rot));
      opacity: 1;
   }
   72% {
      transform: translateY(0) rotate(var(--rot));
      opacity: 1;
   }
   90% {
      transform: translateY(0) rotate(var(--rot));
      opacity: 0;
   }
   100% {
      transform: translateY(-55px) rotate(var(--rot));
      opacity: 0;
   }
}

/* Transición de los mensajes rotativos */
.tal-msg-fade-enter-active,
.tal-msg-fade-leave-active {
   transition: opacity 0.5s ease;
}
.tal-msg-fade-enter,
.tal-msg-fade-leave-to {
   opacity: 0;
}
</style>
